/**
 * DD-ADMIN-PAGE-0728 — platform-owner identity, client side.
 *
 * COSMETIC ONLY. This exists so the owner-only Users tab is not rendered for accounts that would
 * immediately get a 403 — it is NOT a security boundary. Anything shipped to a browser is
 * readable and editable by whoever is holding the browser, so the real gate is
 * `core.authz.verify_platform_owner` on GET /api/account/admin/users, backed by an independent
 * re-check inside `admin_user_service.list_platform_users`. Deleting this file would expose a
 * tab, not any data.
 *
 * Mirrors `backend/src/core/platform_owner.py`. Keyed on the Cognito `sub` (immutable, not
 * user-settable) rather than the email attribute, matching the server.
 */

export const PLATFORM_OWNER_USER_ID = 'e40834a8-80b1-7025-ee09-b542c0b93fcb';

/** True when the signed-in user is the platform owner. `user.user_id` is the Cognito sub — the
 *  shape the auth endpoints return (routers/auth.py: `"user_id": user_claims.get("sub")`). */
export function isPlatformOwner(user) {
  return Boolean(user) && user.user_id === PLATFORM_OWNER_USER_ID;
}

export default isPlatformOwner;
